export const CHANGE_ITEM = "score/CHANGE_ITEM";
export const CHANGE_FACTOR_VALUE = "score/CHANGE_FACTOR_VALUE";
export const CHANGE_SCORE_CARD = "score/CHANGE_SCORE_CARD";
export const SUBMIT_SCORE = "score/SUBMIT_SCORE";
export const AUTO_SAVE = "score/AUTO_SAVE";
export const LOAD_AUTO_SAVE = "score/LOAD_AUTO_SAVE";
export const CHECK_AUTO_SAVE = "score/CHECK_AUTO_SAVE";
export const DISMISS_AUTO_SAVE = "score/DISMISS_AUTO_SAVE";
export const SHOW_COPY_PROMPT = "score/SHOW_COPY_PROMPT";
export const COPY_CONFIRM = "score/COPY_CONFIRM";
export const COPY_CANCEL = "score/COPY_CANCEL";

// 项目级多表 Tab 化
export const LOAD_ALL_TABLES = "score/LOAD_ALL_TABLES";
export const SWITCH_TABLE = "score/SWITCH_TABLE";
export const TABLE_VALUE_CHANGE = "score/TABLE_VALUE_CHANGE";
